"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindTurbines$ = exports.WindTurbines$outboundSchema = exports.WindTurbines$inboundSchema = void 0;
exports.windTurbinesToJSON = windTurbinesToJSON;
exports.windTurbinesFromJSON = windTurbinesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const meta_js_1 = require("./meta.js");
/** @internal */
exports.WindTurbines$inboundSchema = z.object({
    has_wind_turbines: z.nullable(z.boolean()),
    meta: z.nullable(meta_js_1.Meta$inboundSchema),
    number_of_turbines: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "has_wind_turbines": "hasWindTurbines",
        "number_of_turbines": "numberOfTurbines",
    });
});
/** @internal */
exports.WindTurbines$outboundSchema = z.object({
    hasWindTurbines: z.nullable(z.boolean()),
    meta: z.nullable(meta_js_1.Meta$outboundSchema),
    numberOfTurbines: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        hasWindTurbines: "has_wind_turbines",
        numberOfTurbines: "number_of_turbines",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var WindTurbines$;
(function (WindTurbines$) {
    /** @deprecated use `WindTurbines$inboundSchema` instead. */
    WindTurbines$.inboundSchema = exports.WindTurbines$inboundSchema;
    /** @deprecated use `WindTurbines$outboundSchema` instead. */
    WindTurbines$.outboundSchema = exports.WindTurbines$outboundSchema;
})(WindTurbines$ || (exports.WindTurbines$ = WindTurbines$ = {}));
function windTurbinesToJSON(windTurbines) {
    return JSON.stringify(exports.WindTurbines$outboundSchema.parse(windTurbines));
}
function windTurbinesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.WindTurbines$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'WindTurbines' from JSON`);
}
//# sourceMappingURL=windturbines.js.map